<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>仓储管理</el-breadcrumb-item>
      <el-breadcrumb-item>仓库信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加仓库信息按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" size="mini" icon="el-icon-plus" plain
            @click="handleAdd">新增</el-button>
          <el-button id="pdfDom" icon="el-icon-download" plain @click="getpdfyes" class="download" type="warning"
            size="mini">导出</el-button>
        </el-col>
      </el-row>
      <div>
        <el-table :data="warehouselist">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="仓库编号" prop="WarehouseNO" align="center"></el-table-column>
          <el-table-column label="仓库名称" prop="WarehouseName" align="center"></el-table-column>
          <el-table-column label="是否使用" prop="Is_Use" align="center"></el-table-column>
          <el-table-column label="创建时间" prop="CreateTimeConvert" align="center">
            <template slot-scope="scope">
              {{ scope.row.CreateTimeConvert }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="备注" prop="Remark" align="center"></el-table-column> -->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="mini" @click="removeWareHouse(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="getTypeList.page" :page-sizes="[5, 10, 15]" :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" style="text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 添加物料的对话框 -->
    <el-dialog title="添加仓库信息" :visible.sync="addDialogVisible" width="500px" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="仓库名称" prop="WarehouseName">
          <el-input v-model="addForm.WarehouseName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="仓库编号" prop="WarehouseNO">
          <el-input v-model="addForm.WarehouseNO" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="是否使用" prop="Is_Use">
          <el-select v-model="addForm.Is_Use" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="备注" prop="Remark">
          <el-input
            v-model="addForm.Remark"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="设备图片" prop="">
          <el-upload class="upload-demo" drag action="#" :limit="1" :on-change="handleChange" :on-remove="handleRemove"
            :file-list="fileList" :auto-upload="false" accept=".jpeg,.jpg,.png">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addWareHouse">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑仓库信息的会话框 -->
    <el-dialog title="修改仓库信息" :visible.sync="editDialogVisible" width="500px" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="仓库名称" prop="WarehouseName">
          <el-input v-model="editForm.WarehouseName"></el-input>
        </el-form-item>
        <el-form-item label="仓库编号" prop="WarehouseNO">
          <el-input v-model="editForm.WarehouseNO"></el-input>
        </el-form-item>
        <el-form-item label="设备图片" prop="">
          <el-upload class="upload-demo" drag action="#" :limit="1" :on-change="handleChange" :on-remove="handleRemove"
            :file-list="fileList" :auto-upload="false" accept=".jpeg,.jpg,.png">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editWarehouse">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getTypeList: {
        page: 1,
        limit: 5,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      getTypeList1: {
        page: 1,
        limit: 100,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      // 查询参数对象
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      // 仓库信息列表
      warehouselist: [],
      // 总数据条数
      total: 0,
      // 控制添加对话框的开启与关闭
      addDialogVisible: false,
      // 添加仓库信息的表单数据
      addForm: {
        WarehouseName: "",
        WarehouseNO: "",
        CreateTime: "",
        Is_Use: "",
        Remark: "",
      },
      //添加表单的验证规则对象
      addFormRules: {
        WarehouseName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "类型名称的长度在2~10个字符之间",
            trigger: "blur",
          },
        ],
        WarehouseNO: [
          { required: true, message: "请输入仓库编号", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "用户名的长度在2~15个字符之间",
            trigger: "blur",
          },
        ],
        CreateTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      // 控制编辑对话框的显示与隐藏
      editDialogVisible: false,
      // 编辑仓库信息的表单数据
      editForm: {},
      // 修改表单的验证规则对象
      editFormRules: {
        WarehouseName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
        ],
        WarehouseNO: [
          { required: true, message: "请输入仓库编号", trigger: "blur" },
        ],
      },
      // 是否启用
      options: [
        {
          value: "Y",
          label: "是",
        },
        {
          value: "N",
          label: "否",
        },
      ],
      fileList: [],
    };
  },
  created() {
    this.getWareHouseList();
    // this.getWareHouseList1();
  },

  methods: {
    // 打开添加的弹框
    handleAdd() {
      this.fileList = []
      this.addDialogVisible = true
    },
    // 上传文件
    async uploadImg(formName) {
      const urlList = (this.fileList ?? []).filter(i => !i.raw).map(i => i.url)

      if (urlList && urlList[0]) { return false }

      if (this.fileList.length <= 0) {
        this.addForm.Remark = ""
        this.editForm.Remark = ""
        return false
      }

      const file = this.fileList[0]
      const formData = new FormData()

      formData.append('file', file.raw)

      const { data: res } = await this.$http.post(
        "/WMS/upload",
        formData
      )

      this[formName].Remark = res.success ? res.filePath : "";
    },
    handleRemove(_, fileList) {
      this.fileList = fileList;
    },
    handleChange(_, fileList) {
      this.fileList = fileList;
    },
    // 调用接口获取仓库信息
    async getWareHouseList() {
      const { data: res } = await this.$http.get("/WMS/queryWareHouse", {
        params: this.getTypeList,
      });
      console.log(res.data);
      this.warehouselist = res.data;
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].Is_Use == "Y") {
          res.data[i].Is_Use = "是";
        }
        if (res.data[i].Is_Use == "N") {
          res.data[i].Is_Use = "否";
        }
      }
    },
    async getWareHouseList1() {
      const { data: res } = await this.$http.get("/WMS/queryWareHouse", {
        params: this.getTypeList1,
      });
      console.log(res.data);
      this.total = res.data.length;
    },
    // 调用接口删除仓库信息
    async removeWareHouse(scope) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }

      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.post(
        "/WMS/deleteWareHouse",
        params
      );
      // console.log(res)
      if (res.code !== 1) {
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getWareHouseList();
      this.getWareHouseList1();
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 调用接口新增仓库信息
    addWareHouse() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;

        await this.uploadImg('addForm')

        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("WarehouseName", this.addForm.WarehouseName);
        params.append("WarehouseNO", this.addForm.WarehouseNO);
        params.append("CreateTime", this.addForm.CreateTime);
        params.append("Is_Use", this.addForm.Is_Use);
        params.append("Remark", this.addForm.Remark);

        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "/WMS/InsertWareHouse",
          params
        );
        console.log(res.data);
        this.$message.success("添加仓库信息成功！");
        // 隐藏添加用户的对话框
        this.addDialogVisible = false;
        // 重新获取用户列表数据
        this.getWareHouseList();
        this.getWareHouseList1();
      });
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    // 展示修改仓库信息的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true;
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.get("/WMS/queryWareHouseID", {
        params,
      });
      console.log(res.data);
      this.editForm = res.data[0];

      this.fileList = ((this.editForm.Remark ?? "").split(',') ?? []).filter(i => i).map(item => ({ name: item, url: item }))
    },
    // 调用接口编辑仓库信息
    editWarehouse() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();

        await this.uploadImg('editForm')

        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("WarehouseNO", this.editForm.WarehouseNO);
        params.append("WarehouseName", this.editForm.WarehouseName);
        params.append("ID", this.editForm.ID);
        params.append("CreateTime", this.editForm.CreateTime);
        params.append("Is_Use", this.editForm.Is_Use);
        params.append("Remark", this.editForm.Remark);
        const { data: res } = await this.$http.post(
          "/WMS/updateWareHouse",
          params
        );
        console.log(res);
        if (res !== 1) {
          this.$message.error("更新仓库信息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getWareHouseList();
        this.getWareHouseList1();
        // 提示修改成功
        this.$message.success("更新仓库信息成功！");
      });
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log("111" + newSize);
      this.getTypeList.limit = newSize;
      this.getWareHouseList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.getTypeList.page = newPage;
      this.getWareHouseList();
    },
    getpdfyes() {
      this.getPdf();
    },
  },
};
</script>

<style lang="less" scoped></style>
